import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';
import InputBase from '@mui/material/InputBase';

export const InputsWrap = styled(Stack)`
  // gross MUI values to line up with regular inputs
  height: 1.5em;
  padding: 8.5px ${(p) => p.theme.spacing(1)};

  flex-direction: row;
  align-items: center;
  gap: 0.05em;
  border: 1px solid ${(p) => p.theme.palette.divider};
  border-radius: ${(p) => p.theme.shape.borderRadius}px;
  &:focus-within {
    outline: 1px solid ${(p) => p.theme.palette.primary.main};
    border-color: ${(p) => p.theme.palette.primary.main};
  }
  &:hover {
    border-color: ${(p) => p.theme.palette.common.black};
  }
`;

export const InputBaseStyled = styled(InputBase)`
  & input {
    text-align: center;
    width: 1.8em;
    &::placeholder {
      font-family: monospace;
    }
  }
`;
